import { BUILD_TAG } from "./generated/get-build-tag";
import { logInfo, logError } from "./Utils/logger"; // add logError if you have it

export function ensureFreshServiceWorker() {
  if (!navigator.serviceWorker?.controller) {
    logInfo("No active SW controller yet — first load", {
      buildTag: BUILD_TAG,
    });
    return;
  }

  // ── 1️⃣ ask active SW for its tag ────────────────────────────────────────────
  logInfo("SW handshake → sending GET_SW_TAG", { buildTag: BUILD_TAG });
  navigator.serviceWorker.controller.postMessage({ type: "GET_SW_TAG" });

  // fallback in case the SW never replies
  const timeout = setTimeout(() => {
    logError("SW handshake timed out (3 s) — forcing refresh");
    forceRefresh();
  }, 3_000);

  // ── 2️⃣ handle the reply ────────────────────────────────────────────────────
  function onMsg(evt: MessageEvent) {
    if (evt.data?.type !== "SW_TAG") return;

    clearTimeout(timeout);
    const swTag = evt.data.tag;
    const same = swTag === BUILD_TAG;

    logInfo("SW handshake ← received tag", {
      uiTag: BUILD_TAG,
      swTag,
      same,
    });

    if (!same) forceRefresh();
    navigator.serviceWorker.removeEventListener("message", onMsg);
  }
  navigator.serviceWorker.addEventListener("message", onMsg);

  // ── 3️⃣ reload when the new SW takes control ────────────────────────────────
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    logInfo("SW controllerchange → reloading page");
    window.location.reload();
  });

  // ── 4️⃣ hourly self-check safety net ─────────────────────────────────────────
  setInterval(() => {
    logInfo("Hourly SW update() check");
    navigator.serviceWorker.getRegistration()?.then((reg) => reg?.update());
  }, 60 * 60_000);

  // ── helper to trigger the hard refresh ──────────────────────────────────────
  function forceRefresh() {
    navigator.serviceWorker.getRegistration()?.then((reg) => {
      if (!reg) return;

      logInfo("SW refresh → registration.update()");
      reg.update().then(() => {
        if (reg.waiting) {
          logInfo("SW refresh → posting SKIP_WAITING to waiting worker");
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        } else {
          logInfo("SW refresh → no waiting worker yet");
        }
      });
    });
  }
}
